import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'ch-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {

  @Output()
  logoutEvent: EventEmitter<void> = new EventEmitter<void>();

  logout() {
    this.logoutEvent.emit();
  }
}
